import type { MarketingProcess } from '../../types/shared';

export const CAMPAIGN_NAME_FILTER: Record<MarketingProcess, string> = {
  'testing': 'CP-Test-Campaign-Template',
  'scaling': 'Scale-Campaign-template',
  'inbox': 'inbox',
  'hypothesis_testing': 'CP-Test-Campaign-Template',
};